export default { path: '*', redirect: '/' }
